import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Add environment flag to the document title in dev/test
const envRaw = import.meta.env.VITE_APP_ENV || import.meta.env.MODE || 'development';
const env = String(envRaw).toLowerCase();
const isProd = env === 'production' || env === 'prod' || env.startsWith('prod');
if (typeof document !== 'undefined') {
  const baseTitle = document.title || 'ICNACON';
  let envLabel = '';
  if (!isProd) {
    if (env === 'development' || env === 'dev') envLabel = 'DEV';
    else if (env === 'test' || env === 'testing') envLabel = 'TEST';
    else envLabel = String(envRaw).toUpperCase();
  }
  document.title = envLabel ? `[${envLabel}] ${baseTitle}` : baseTitle;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);